import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";

interface DatePickerProps {
  selectedDate: Date;
  onChange: (date: Date) => void;
  minDate?: Date;
}

export const DatePicker: React.FC<DatePickerProps> = ({ selectedDate, onChange, minDate }) => {
  return (
    <ReactDatePicker
      selected={selectedDate}
      onChange={(date) => onChange(date || new Date())}
      dateFormat="dd/MM/yyyy"
      placeholderText="Select a date"
      minDate={minDate ?? new Date()}
      inline
    />
  );
};
